export const interactionDurationMetrics = [
    ["ResponseTime", "interaction-response-time", "interaction response time"],
    ["FirstResponseTime", "interaction-first-response-time", "first response time"],
    ["FollowupResponseTime", "interaction-follow-up-response-time", "follow-up response time"],
    ["WhResponseTime", "interaction-wh-response-time", "interaction response time (working hours)"],
    ["WhFirstResponseTime", "interaction-wh-first-response-time", "first response time (working hours)"],
    ["WhFollowupResponseTime", "interaction-wh-follow-up-response-time", "follow-up response time (working hours)"]
].map(([suffix, command, label]) => ({
    average: `averageInteraction${suffix}`,
    median: `medianInteraction${suffix}`,
    command,
    label
}));
